import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { useMarkNotificationRead } from '@/hooks/useNotifications';
import type { NotificationItem } from '@/types/notifications';

/** Click handler for a row: mark it read, then go to its link. */
export function useNotificationClick(onDone?: () => void) {
  const navigate = useNavigate();
  const { mutate: markRead } = useMarkNotificationRead();

  return useCallback(
    (item: NotificationItem) => {
      if (!item.read_at) {
        markRead(item.id);
      }
      if (item.link.startsWith('/')) {
        navigate({ to: item.link });
      }
      onDone?.();
    },
    [markRead, navigate, onDone],
  );
}
